/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiPurewaveSettingMutationRequest, PutApiPurewaveSettingMutationResponse, PutApiPurewaveSetting400, PutApiPurewaveSetting401, PutApiPurewaveSetting403, PutApiPurewaveSetting404, PutApiPurewaveSetting500 } from "../../types/PutApiPurewaveSetting.ts";
import { putApiPurewaveSettingMutationResponseSchema, putApiPurewaveSettingMutationRequestSchema } from "../../zod/PureWaveSettingSchemas/putApiPurewaveSettingSchema.ts";

function getPutApiPurewaveSettingUrl() {
  const res = { method: 'PUT', url: `/api/purewave-setting` as const }  
  return res
}

/**
 * @summary Обновление частоты треков и подкастов
 * {@link /api/purewave-setting}
 */
export async function putApiPurewaveSetting({ data }: { data?: PutApiPurewaveSettingMutationRequest }, config: Partial<RequestConfig<PutApiPurewaveSettingMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiPurewaveSettingMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiPurewaveSettingMutationResponse, ResponseErrorConfig<PutApiPurewaveSetting400 | PutApiPurewaveSetting401 | PutApiPurewaveSetting403 | PutApiPurewaveSetting404 | PutApiPurewaveSetting500>, PutApiPurewaveSettingMutationRequest>({ method : "PUT", url : getPutApiPurewaveSettingUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiPurewaveSettingMutationResponseSchema.parse(res.data)
}